
// -------------------------------------------- Paga load with fade-in
if (document.readyState === 'loading') {
	document.body.classList.add('--loading');
	document.addEventListener('DOMContentLoaded', function () {
		document.body.classList.remove('--loading');
	});
}
else {
	document.body.classList.remove('--loading');
}


// Removes --loading class on page unload (mandatory to make page visible on history.back()
window.addEventListener('unload', function (event) {
	document.body.classList.remove('--loading');
});

// Event listener on internal links to handle page fade-out on navigation
let links = document.querySelectorAll('a');
links.forEach(function (el, idx) {

	if ((el.hasAttribute('href'))
		&& (el.getAttribute('target') != "_blank")
		&& (el.getAttribute('href') != '#')
		&& (el.getAttribute('href') != '')
		&& (el.getAttribute('href').indexOf('javascript:void(0)') < 0)) {

		el.addEventListener('click', function (e) {
			e.preventDefault();
			document.body.classList.add('--loading');
			setTimeout(function () { window.location.href = el.getAttribute('href'); }, 400);
		});
	}
});